import { type PropsWithChildren } from 'react';

import { emojiShape } from './EmojiShape.sty.js';

/** @internal */
export interface EmojiShapeProps {
  active?: boolean;
  label?: string;
}

export const EmojiShape = ({
  active = false,
  label = 'emojiShape',
  children,
}: PropsWithChildren<EmojiShapeProps>) => {
  return (
    <div role="img" aria-label={label} className={emojiShape({ active })}>
      {children}
    </div>
  );
};

EmojiShape['displayName'] = 'EmojiShape';
